export const getVisibleFieldError = (meta: { error?: string; submitFailed?: boolean; touched?: boolean }) => {
	return meta.error && (meta.submitFailed || meta.touched) ? meta.error : undefined;
};
